<!-- Notifications toggle -->
<button
    mat-icon-button
    (click)="openPanel()"
    #notificationsOrigin>
    <ng-container>
        <span class="absolute top-0 right-0 left-0 flex items-center justify-center h-3">
          <span class="flex items-center justify-center shrink-0 min-w-4 h-4 px-1 ml-4 mt-2.5 rounded-full bg-teal-600 text-indigo-50 text-xs font-medium" style="z-index:999">
            {{unreadActivityCount}}
          </span>
        </span>
    </ng-container>
    <mat-icon [svgIcon]="'heroicons_outline:bell'"></mat-icon>
</button>

<!-- Notifications panel -->
<ng-template #notificationsPanel>

    <div class="fixed inset-0 sm:static sm:inset-auto flex flex-col sm:min-w-90 sm:w-90 sm:rounded-2xl overflow-hidden shadow-lg">

        <!-- Header -->
        <div class="flex shrink-0 items-center py-4 pr-4 pl-6  text-on-primary" style="background: #0C2459">
            <div class="sm:hidden -ml-1 mr-3">
                <button data-case-id="btn_closenotpanel"
                    mat-icon-button
                    (click)="closePanel()">
                    <mat-icon
                        class="icon-size-5 text-current"
                        [svgIcon]="'heroicons_solid:x-mark'"></mat-icon>
                </button>
            </div>
            <div class="text-lg font-medium leading-10">{{ 'Activity' | translate}}</div>
            <div class="ml-auto">
              <button mat-icon-button data-case-id="btn_gotoactivity"
                      [matTooltip]="'ViewAll'|translate"
                      [disabled]="unreadCount === 0"
                      [routerLink]="'/activities'"  (click)="closePanel()">
                <mat-icon class="icon-size-5 text-current" style="color:#fff !important">pageview</mat-icon>
              </button>

            
            </div>
        </div>

        <!-- Content -->
        <div class="relative flex flex-col flex-auto sm:max-h-120 divide-y overflow-y-auto bg-card">

          <notification-list [activity_list]="latestActivity" (click)="closePanel()"></notification-list>

        </div>

    </div>

</ng-template>
